import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import duster from "../../../../assets/info/duster-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import { popularVehicle } from "../../../../vars/popularVehicles";

const DaciaDuster = () => {
  useSmallNav("Dacia Duster");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Dacia Duster"} bolder />
        <InfoHero image={duster} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Dacii Duster? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader size="smaller" text={"Trafiłeś we właściwe miejsce."} />
            <p>
              Duster to świetny pojazd w atrakcyjnej cenie, ale w zależności od
              sposobu użytkowania możesz szukać czegoś więcej od seryjnego
              zawieszenia Duster.
            </p>
            <p>
              W Pedders Suspension oferujemy szeroką gamę części zawieszenia, w
              tym ulepszone amortyzatory i sprężyny.
            </p>
            <p>
              Oprócz ulepszonych amortyzatorów podwyższamy również sprężyny,
              zarówno w wersjach komfortowych, jak i ciężkich. Niezależnie od
              zastosowania, posiadamy niezbędne części do wykonania tego
              zadania.
            </p>
            <p>
              Zapraszamy do zapoznania się z naszymi częściami i zestawami do
              Dustera.
            </p>
            <p>
              Nie wiesz, czego potrzebujesz? W takim razie skontaktuj się z
              nami, a nasz zespół będzie w stanie Ci pomóc.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Dacia Duster Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Dacia Duster Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Dacia")
              .models.find((e) => e.display === "Duster")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default DaciaDuster;
